import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {i18n} from '../../Utility/Format';
import {getCcyPairsFromParameters, getCcyPairsAsParameters} from '../../Utility/CurrencyPairHelper';
import Button from '../../Components/Controls/Button';
import Icon from '../../Components/Helper/Icon';
import CurrencyPairOptions from './CurrencyPairOptions';

export default class HomeOptions extends Component {
    static propTypes = {
        currencies: PropTypes.array,
        options: PropTypes.object.isRequired,

        onCcyPairsChange: PropTypes.func.isRequired,
        onMenuToggle: PropTypes.func.isRequired,
        onReset: PropTypes.func.isRequired,
        locale: PropTypes.string.isRequired,
    };

    render() {
        const changeCurrencyPairOption = (index, status, newValue) => {
            if (!newValue || !newValue.isoString) {
                console.warn("newValue is undefined or doesn't have isoString, ignoring");
                return;
            }

            const currentPairs = getCcyPairsFromParameters(this.props.options.ccyPairs, this.props.currencies);

            const newPairs = currentPairs.map((pair, i) => {
                if (i !== index) {
                    return pair;
                }

                // Create a new pair object to avoid mutation
                const newPair = { ...pair };
                newPair[status] = newValue; // The currency dropdown seems to send the full object

                return newPair;
            });

            this.props.onCcyPairsChange(getCcyPairsAsParameters(newPairs));
        };

        const toggleMenu = (e) => {
            this.props.onMenuToggle(e, this.props.options);
        };

        const resetOptions = () => {
            this.props.onReset();
        };
        //console.log(this.props.ccyPairs);
        //console.log(this.props.currencies);
        return (
            <div>
                <section>
                    <p>{i18n('dbm.home.options.changeCurrencyPairs')}</p>
                    <CurrencyPairOptions
                        currencyPairs={getCcyPairsFromParameters(this.props.options.ccyPairs, this.props.currencies)}
                        currencies={this.props.currencies}                        
                        onChangeCurrencyPair={changeCurrencyPairOption}
                        showRemoveButton={false}
                        locale={this.props.locale}/>
                </section>

                <div className="drawerPanel__panel__content--footer">
                    <Button
                        onClick={(e) => toggleMenu(e)}>
                        <Icon name="check-lg" isCollapsed={true}/> {i18n('dbm.home.options.saveOptionsButton')}
                    </Button>
                    <Button
                        className="button button--borderless"
                        onClick={resetOptions}>
                        <Icon name="reset" isCollapsed={true}/> {i18n('dbm.home.options.resetOptionsButton')}
                    </Button>
                </div>
            </div>
        );
    }
};